<template lang="html">
  <div class="my-team-settings">
    <div class="section-header">
      <h2>My team</h2>
    </div>

    <form class="setting" @submit.prevent="saveTeamName">
      <label>Team name</label>
      <input
      type="text"
      required
      maxlength="20"
      placeholder="Team name"
      v-model="teamName"
      >
      <button type="submit">Save</button>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      teamNameSave: this.teamName,
    };
  },

  computed: {
    ...mapGetters({
      myTeam: 'draft/myTeam',
    }),

    teamName: {
      get() {
        return this.myTeam.name;
      },

      set(value) {
        this.teamNameSave = value;
      },
    },
  },

  methods: {
    saveTeamName() {
      this.$store.dispatch('draft/SAVE_TEAMS', { teamName: this.teamNameSave })
        .then(() => {
          this.$toast({ message: 'Saved your team name' });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "./settings";

  .my-team-settings {
    @include settingSection;
  }
</style>
